var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 24.125C14.0266 24.125 15.5383 23.8243 16.9487 23.2401C18.3591 22.6559 19.6406 21.7996 20.7201 20.7201C21.7996 19.6406 22.6559 18.3591 23.2401 16.9487C23.8243 15.5383 24.125 14.0266 24.125 12.5C24.125 10.9734 23.8243 9.46171 23.2401 8.0513C22.6559 6.64089 21.7996 5.35936 20.7201 4.27988C19.6406 3.2004 18.3591 2.34411 16.9487 1.7599C15.5383 1.17569 14.0266 0.875 12.5 0.875C9.41686 0.875 6.45999 2.09977 4.27988 4.27988C2.09977 6.45999 0.875 9.41686 0.875 12.5C0.875 15.5831 2.09977 18.54 4.27988 20.7201C6.45999 22.9002 9.41686 24.125 12.5 24.125ZM12.2003 17.2017L18.6587 9.45167L16.6747 7.79833L11.1205 14.462L8.24654 11.5868L6.42013 13.4132L10.2951 17.2882L11.2949 18.288L12.2003 17.2017Z",
    fill: "#3873FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.53f85d8411141047a23a270559b27e74.svg";
export { ForwardRef as ReactComponent };